"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateTransporter = exports.getTransporters = exports.getTransporterById = exports.deleteTransporter = exports.defaultTransporterData = exports.createTransporters = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultTransporterData = exports.defaultTransporterData = {
  id: 0,
  enabled: true,
  name: '',
  mobileNumber: '',
  gstNumber: '',
  freightCharge: 0
};
const getTransporters = params => (0, _request.default)({
  url: '/transporters',
  method: 'get',
  params
});
exports.getTransporters = getTransporters;
const getTransporterById = id => (0, _request.default)({
  url: `/transporters/${id}`,
  method: 'get'
});
exports.getTransporterById = getTransporterById;
const updateTransporter = (id, data) => (0, _request.default)({
  url: `/transporters/${id}`,
  method: 'patch',
  data
});
exports.updateTransporter = updateTransporter;
const deleteTransporter = id => (0, _request.default)({
  url: `/transporters/${id}`,
  method: 'delete'
});
exports.deleteTransporter = deleteTransporter;
const createTransporters = data => (0, _request.default)({
  url: '/transporters',
  method: 'post',
  data
});
exports.createTransporters = createTransporters;